import { render, staticRenderFns } from "./TableGridWidget.vue?vue&type=template&id=2508b357&scoped=true&"
import script from "./TableGridWidget.vue?vue&type=script&lang=ts&"
export * from "./TableGridWidget.vue?vue&type=script&lang=ts&"
import style0 from "./TableGridWidget.vue?vue&type=style&index=0&id=2508b357&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2508b357",
  null
  
)

export default component.exports